(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.DefaultController = (function(superClass) {
    extend(DefaultController, superClass);

    function DefaultController($scope, $state, $window, $stateParams, Session, Routing) {
      if (!Session.get('Authorization')) {
        $state.go('login', $stateParams);
      } else {
        Routing.determineDestination($stateParams);
      }
    }

    return DefaultController;

  })(Controller);

}).call(this);
